/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { B2BOrgUnit } from './B2BOrgUnit';
import {
    B2BOrgUnitFromJSON,
    B2BOrgUnitFromJSONTyped,
    B2BOrgUnitToJSON,
} from './B2BOrgUnit';

/**
 * Representation of an organizational unit list
 * @export
 * @interface B2BOrgUnitList
 */
export interface B2BOrgUnitList {
    /**
     * List of B2B orgUnit
     * @type {Array<B2BOrgUnit>}
     * @memberof B2BOrgUnitList
     */
    orgUnits: Array<B2BOrgUnit>;
}

/**
 * Check if a given object implements the B2BOrgUnitList interface.
 */
export function instanceOfB2BOrgUnitList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "orgUnits" in value;

    return isInstance;
}

export function B2BOrgUnitListFromJSON(json: any): B2BOrgUnitList {
    return B2BOrgUnitListFromJSONTyped(json, false);
}

export function B2BOrgUnitListFromJSONTyped(json: any, ignoreDiscriminator: boolean): B2BOrgUnitList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orgUnits': ((json['orgUnits'] as Array<any>).map(B2BOrgUnitFromJSON)),
    };
}

export function B2BOrgUnitListToJSON(value?: B2BOrgUnitList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orgUnits': ((value.orgUnits as Array<any>).map(B2BOrgUnitToJSON)),
    };
}

